<template>
  <section>
    <v-dialog
      v-model="dialog"
      fullscreen>
      <div class="header flex">
        <p>Review
          <span
            v-if="hasBankPayment||isNewSME"
            class="pointer"
            :class="{'blue':pdf_type==1}"
            @click="handlePDF(1)">Payment</span>
          {{hasBankPayment&&hasPropPdf?' | ':''}}
          <span
            v-if="hasPropPdf"
            class="pointer"
            :class="{'blue':pdf_type==2}"
            @click="handlePDF(2)"> Application</span></p>
        <font-awesome-icon
          icon="times"
          class="close"
          @click="handleCancel"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <div class="form-card">
          <div class="form-left">
            <div class="upload-card">
              <embed
                v-if="isPdf"
                :src="photoUrl"
                width="100%"
                height="100%"
                type="application/pdf">
              <el-image
                v-else
                :src="photoUrl"
                :preview-src-list="[photoUrl]"
              >
              </el-image>
            </div>
          </div>
          <div class="form-right">
            <div class="box flex">
              <div class="r-left">
                <span class="content-title">Payment Details</span>
                <el-form
                  ref="form"
                  :rules="rules"
                  :model="formData">
                  <div class="form-item">

                    <span>Method</span>
                    <span v-if="!hasBankPayment&&!isNewSME">
                      <span
                        v-for="(item,index) in payment_record.method"
                        :key="index">{{item}}</span>
                    </span>
                    <el-form-item
                      v-else
                      prop="pay_type"
                      :rules="rules.select">
                      <v-select
                        v-model="formData.pay_type"
                        :list="payOptions" />
                    </el-form-item>
                  </div>
                  <div class="form-item i-datetime-picker">
                    <span>Transaction Date</span>
                    <span v-if="!hasBankPayment&&!isNewSME">{{payment_record.success_at}}</span>
                    <el-form-item
                      v-else
                      prop="transaction_date"
                      :rules="rules.select">
                      <el-date-picker
                        v-model="formData.transaction_date"
                        format="dd-MM-yyyy HH:mm"
                        placeholder="dd-MM-yyyy HH:mm"
                        valueFormat="yyyy-MM-dd HH:mm"
                        type="datetime">
                      </el-date-picker>
                      <!--                      <v-datetime-picker v-model="formData.transaction_date" />-->
                    </el-form-item>
                  </div>
                  <template v-if="hasBankPayment||isNewSME">
                    <div class="form-item">
                      <span>Reference No.</span>
                      <el-form-item prop="reference_no">
                        <v-input
                          v-model="formData.reference_no"
                        ></v-input>
                      </el-form-item>
                    </div>
                    <div class="form-item">
                      <span>Remarks</span>
                      <el-form-item prop="remark">
                        <v-input
                          v-model="formData.remark"
                          type="textarea"
                          :rows="5"
                        ></v-input>
                      </el-form-item>
                    </div>
                  </template>
                  <div class="form-item">
                    <!--                    <span>Items for approval</span>-->
                    <el-form-item>
                      <!--                      <v-checkbox-group-->
                      <!--                        v-model="item_select"-->
                      <!--                        :list="itemsList"-->
                      <!--                        block-->
                      <!--                        @check="changeItems"-->
                      <!--                      >-->
                      <!--                      </v-checkbox-group>-->
                      <template v-if="!isNewSME">
                        <div
                          v-if="hasBankPayment"
                          class="card-table">
                          <div
                            class="header flex">
                            <v-checkbox
                              v-model="item_select_bank"
                              :isBoolean="false"
                              :select-number="1"
                              @change="changeItems">
                              Approve bank transaction record
                            </v-checkbox>
                          </div>
                          <div class="tr">
                            <span
                              v-if="bankPayment.url"
                              class="blue flie-name-len pointer"
                            >{{ bankPayment.client_name }}</span>
                            <span
                              v-else
                              class="missing">No File</span>
                            <span class="flex action-list">

                              <v-upload
                                btnType="text"
                                class="mg-r-15"
                                :uploadData="{
                                  order_id: orderId,
                                  type: 'bank_payment_path'
                                }"
                                :direct="0"
                                :label="bankPayment.url? 'Replace': 'Upload'"
                                @uploadSuccess="handlerUploadSuccess"
                              />
                              <span
                                v-if="bankPayment.url"
                                class="danger pointer "
                                @click="handlerDelete('bank_payment_path',bankPayment.client_name)"
                              >Delete</span>
                            </span>
                          </div>
                        </div>
                        <div
                          v-if="hasPropPdf"
                          class="card-table">
                          <div   class="header flex">
                            <v-checkbox
                              v-model="item_select_approve"
                              :isBoolean="false"
                              :select-number="2"
                              @change="changeItems">
                              Approve application form
                            </v-checkbox>
                          </div>
                          <div class="tr">
                            <span
                              v-if="prop_pdf.url"
                              class="blue flie-name-len pointer"
                            >{{ prop_pdf.client_name }}</span>
                            <span
                              v-else
                              class="missing">No File</span>
                            <span class="flex action-list">

                              <v-upload
                                btnType="text"
                                class="mg-r-15"
                                :uploadData="{
                                  order_id: orderId,
                                  type: 'prop_pdf_path'
                                }"
                                :direct="0"
                                :label="prop_pdf.url? 'Replace': 'Upload'"
                                @uploadSuccess="handlerUploadSuccess"
                              />
                              <span
                                v-if="prop_pdf.url"
                                class="danger pointer"
                                @click="handlerDelete('prop_pdf_path',prop_pdf.client_name)"
                              >Delete</span>
                            </span>
                          </div>
                        </div>
                      </template>
                      <div
                        v-if="isNewSME"
                        class="card-table">
                        <div   class="header flex">
                          <v-checkbox
                            v-model="item_select_sme"
                            :isBoolean="false"
                            :select-number="1"
                            @change="changeItems">
                            Approve Payment Record
                          </v-checkbox>
                        </div>
                        <div class="tr">
                          <span
                            v-if="payment_files.url"
                            class="blue flie-name-len pointer"
                          >{{ payment_files.client_name }}</span>
                          <span
                            v-else
                            class="missing">No File</span>
                          <span class="flex action-list">

                            <v-upload
                              btnType="text"
                              class="mg-r-15"
                              :uploadData="{
                                order_id: orderId,
                                type: 'payment_files'
                              }"
                              :direct="0"
                              :label="payment_files.url? 'Replace': 'Upload'"
                              @uploadSuccess="handlerUploadSuccess"
                            />
                            <span
                              v-if="payment_files.url"
                              class="danger pointer"
                              @click="handlerDelete('payment_files',payment_files.client_name)"
                            >Delete</span>
                          </span>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div class="r-right">

                <div class="flex-content">

                  <div class="flex-box">
                    <div class="flex-icon">
                      <div class="flex-algin">
                        <span
                          class="icon icon-content">
                          <img
                            v-if="!isNewSME"
                            :src="plan_info.company_icon"
                            alt="company"/>
                          <img
                            v-else
                            :src="getOptionData('companySmallIcon', detail.company_id).logo"
                            alt="company"/>
                        </span>
                        <span
                          class="icon icon-content"
                        >
                          <font-awesome-icon
                            v-if="detail.class_id"
                            :icon="getOptionName('iconOptions', detail.class_id)" />
                        </span>
                      </div>
                      <div class="flex-sb">
                        <span class="label blue break-work">{{ planName }}</span>
                        <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
                      </div>
                    </div>
                    <div
                      v-for="(item, index) in sidebarPremium"
                      :key="index"
                      class="flex-info">
                      <span>{{ item.item }}</span>
                      <!--                <span>{{ item.premium | formatMoney(2, true) }}</span>-->
                      <span>{{ item.premium_str }}</span>
                    </div>

                    <div
                      class="flex-info total-amount">
                      <span>Total Payable</span>
                      <span class="amount">{{ amountResult | formatMoney(2, true) }}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="dialog-footer">
              <v-button
                gray
                @click="handleCancel(0)">Cancel</v-button>
              <div>
                <v-button
                  red
                  :disabled="!hasBankPayment&&!isNewSME"
                  @click="handleApprove(0)">Reject</v-button>
                <v-button
                  green
                  :disabled="!canApproveUrl||!is_item_select"
                  @click="handleApprove(1)"
                >Approve
                </v-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
    <bank-transfer-sms
      ref="bank-transfer-sms"
      :form="detail"
      :isNewSME="isNewSME"
      @getResult="handleResult"></bank-transfer-sms>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import {reviewBankPayment} from '@api/share'
import BankTransferSms from './bank-transfer-sms'
import {deleteOrderFile} from '@api/order'
import {approveSMEPayment} from '../../../../../api/new_sme'
import dayjs from 'dayjs'
export default {
  name: 'ReviewPayment',
  components:{
    BankTransferSms
  },
  mixins: [MixinOptions, MixinFormat,MixinRules],
  props:{
    orderId:{
      type: [Number,String],
      default: 0
    },
    detail:{
      type: Object,
      default: ()=>({})
    },
    isNewSME:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      dialog: false,
      pdf_type:1,
      item_select_bank:'',
      item_select_approve:'',
      item_select_sme:'',
      formData:{
        remark:'',
        reference_no:'',
        transaction_date:'',
        pay_type:''
      }
    }
  },
  computed:{
    pcy_id(){
      let {pcy_id} = this.detail||{}
      return pcy_id
    },
    payment_record(){
      let {payment_record=[],payment_files} = this.detail||{}
      if(this.isNewSME){
        return payment_files
      }
      if(payment_record.length<=0)
        return {}
      let {record=[]} = payment_record[0]
      return record[0]||{}
    },
    item_select(){
      let arr = [this.item_select_bank,this.item_select_approve,this.item_select_sme]
      arr = arr.filter(item=>item!=0)
      return arr
    },
    is_item_select(){
      let {bank_payment={},prop_pdf={},share_guest_type,stts} = this.detail||{}
      let length = this.pcy_id==0&&share_guest_type!=1&&stts==270?2:1
      if(this.isNewSME)
        length = 1
      return this.item_select.length == length
    },
    photoUrl() {
      let {bank_payment={},prop_pdf={}} = this.detail||{}
      let pdf_data = this.pdf_type==1?bank_payment:prop_pdf
      if(this.isNewSME)
        pdf_data = this.payment_files
      return pdf_data && pdf_data.url || ''
    },
    canApproveUrl(){
      let {bank_payment={},prop_pdf={},share_guest_type,stts} = this.detail||{}
      if(this.isNewSME){
        return true
      }
      if(this.hasBankPayment&&!this.hasPropPdf){
        return bank_payment&&bank_payment.url?true:false
      }
      if(this.hasBankPayment&&this.hasPropPdf){
        return bank_payment&&bank_payment.url&&prop_pdf&&prop_pdf.url?true:false
      }else
        return prop_pdf&&prop_pdf.url?true:false
    },
    plan_info(){
      let {quote_coverage_list,sidebar_info} = this.detail||{}
      let {plan_info} =quote_coverage_list||{}

      return plan_info||{}
    },
    planName(){
      return this.detail.plan
    },
    sidebarPremium() {
      let coverageList
      let {sidebar_premium=[]} = this.detail.quote_coverage_list||{}
      let {sidebar_info} = this.detail||{}
      coverageList = sidebar_premium||[]
      if(this.isNewSME)
        return sidebar_info
      if(!coverageList) {
        return []
      }
      let premium =coverageList.filter(item => item.name != 'paid')
      return  premium
    },
    amountResult(){
      const { amount } = this.detail||{}
      return  amount||0
    },
    hasPropPdf(){
      let {share_guest_type} = this.detail||{}
      return share_guest_type!=1&&!this.isNewSME
    },
    hasBankPayment(){
      let {pcy_id,stts} = this.detail||{}
      return pcy_id==0&&stts==270
    },
    bankPayment(){
      let {bank_payment} = this.detail||{}
      return bank_payment||{}
    },
    prop_pdf(){
      let {prop_pdf} = this.detail||{}
      return prop_pdf||{}
    },
    payment_files(){
      let {payment_files} = this.detail||{}
      return payment_files||{}
    },
    isPdf() {
      let {bank_payment={},prop_pdf={}} = this.detail||{}
      let pdf_data = this.pdf_type==1?bank_payment:prop_pdf
      if(pdf_data) {
        const { client_name } = pdf_data
        if(String(client_name).toLowerCase().indexOf('.pdf') != -1) {
          return true
        }
      }
      return false
    }
  },
  watch:{
    hasBankPayment:{
      immediate:true,
      handler(val){
        this.pdf_type=val?1:2
      }
    }
  },
  mounted() {
    // this.formData.transaction_date = dayjs(new Date()).format('YYYY-MM-DD hh:mm')
  },
  methods: {
    handlerUploadSuccess({ data, result, otherData }) {
      this.$emit('update')
    },
    handlerDelete(type,name) {
      this.$ConfirmBox({
        message: `Are you sure you wana delete ${name}?`
      }).then(()=>{
        this.network().deleteOrderFile(type)
      })
    },
    changeItems(val){
      this.pdf_type=val
    },
    handlePDF(type){
      this.pdf_type=type
    },
    changeDialog(){
      this.dialog = !this.dialog
    },
    handleCancel(){
      this.dialog = false
      // this.changeDialog()
    },
    handleApprove(status){
      let params = {...this.formData,order_id:this.detail.id}
      if(this.isNewSME){
        params.order_id = this.orderId
      }
      params.status = status
      if(status==0){
        this.$refs['form'].clearValidate()
        this.$ConfirmBox({
          isNewConfirm:true,
          width:500,
          title:'Reject Payment',
          confirmBtn:'Reject',
          message: 'Are you sure to discard this payment? The payment proof will be lost.'
        }).then(() => {
          // if(this.isNewSME){
          //   this.handleResult()
          // }else
          this.$refs['bank-transfer-sms'].changeDialog('reject')
        })
      }else{
        this.$refs['form'].validate(valid => {
          if(valid){
            if(this.isNewSME)
            {
              this.network().approveSMEPayment(params)
              return
            }
            this.network().reviewBankPayment(params)
          }
        })
      }
    },
    handleResult(options){
      let params = {
        ...this.formData,
        order_id:this.detail.id,
        status: 0
      }
      params = Object.assign(params, options)
      this.$refs['bank-transfer-sms'].changeDialog()
      if(this.isNewSME)
      {
        this.network().approveSMEPayment(params)
        return
      }
      this.network().reviewBankPayment(params)
    },
    network(){
      return {
        reviewBankPayment: async(params) => {
          const {data} = await reviewBankPayment(params)
          if(data.code == 1000){
            this.$emit('update')
            this.changeDialog()
          }
        },
        approveSMEPayment: async(params) => {
          params.order_id = this.detail.order_id
          const {data} = await approveSMEPayment(params)
          if(data.code == 1000){
            this.$emit('update')
            this.changeDialog()
          }
        },
        deleteOrderFile: async (type) => {
          const { data } = await deleteOrderFile({
            order_id: this.orderId,
            type,
          })
          this.$message({
            type: 'success',
            message: data.message_language,
          })
          this.$emit('update')
        },

      }
    }
  },
}
</script>
<style lang='scss' scoped>
/deep/.el-dialog{
  //border-radius: 6px;
  .header{
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    //border-radius: 6px 6px 0px 0px;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    p{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      color: #1B1F23;
    }
    .close{
      padding: 0 5px;
      cursor: pointer;
    }
  }
  .dialog-body{
    //padding: 20px 15px 15px 15px;
    .flex{
      display: flex;
    }
    .form-card {
      display: flex;
      background: white;
      border-radius: 4px;
      //border-top: 1px solid rgba(0, 0, 0, 0.1);
      //border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .form-left,
      .form-right {
        // flex: 1;
        width: 50%;
        height: calc( 100vh - 54px);
      }

      .form-left {
        display: flex;
        background: rgb(88, 96, 105);
        flex-direction: column;
        z-index: 1;
      }
      .form-right {
        padding: 20px;
        border-left: 1px solid #dddfe7;
        .content-title{
          font-size: 16px;
          font-weight: 600;
          display: block;
          margin-bottom: 20px;
        }
        .box{
          height: calc(100% - 48px);
          justify-content: space-between;
        }
        .r-left{
          width: 330px;
          margin-right: 50px;
        }
        .r-right{
          width: 280px;
          height: 100%;
          overflow-y: auto;
          overflow-x: hidden;
        }
        .flex-icon{
          padding: 23px 15px;
          border-bottom: 1px solid #E1E4E8;
        }
        .flex-algin{
          margin-bottom: 10px;
          width: 280px;
          display: flex;
          .label{
            margin-top: 0;
            word-break: break-word;
          }
          .icon{
            margin-right: 15px;
            height: 22px;
            width: 22px;
            color: #6A737D;
            border-radius: 5px;
            text-align: center;
            display: inline-block;
            img{
              height: 22px;
              width: 22px;
            }
          }
          .icon-content{
            height: 22px;
            width: 22px;
            border-radius: 5px;
            background-color: #E1E4E8;
            color: #6A737D;
            font-size: 14px;
            text-align: center;
            line-height: 22px;
          }
        }
        .flex-content {
          width: 280px;
          .flex-box {
            border-radius: 5px;
            border: 1px solid #E1E4E8;
            width: 280px;
            margin: 16px 0;

            .flex-info {
              display: flex;
              justify-content: space-between;
              padding: 23px 15px;
              border-bottom: 1px solid #E1E4E8;

              span:first-child {
                color: #586069;
                font-size: 14px;
                font-weight: 500;
                width: 50%;
              }

              span:last-child {
                color: #24292E;
                font-size: 14px;
              }
            }

            .total-amount {
              background: #f6f8fa;
              border-bottom: 0;
            }
            .transa-color{
              span{
                color: rgb(205,43,56)!important;
              }

            }

            .amount {
              color: #24292E;
              font-weight: bolder;
            }
          }
        }
      }

      .form-block {
        margin-bottom: 15px;
        & > span:first-child {
          display: block;
          padding-bottom: 5px;
          color: #616266;
          font-weight: bold;
          font-size: 14px;
        }
      }

      .title {
        display: block;
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
        font-weight: 500;
      }

      .form-flex {
        display: flex;
        justify-content: space-between;

        & > .form-block {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }


    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px;
    }

    .upload-card {
      z-index: 0;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      margin: auto;
      width: 100%;
      height: 100%;
      img {
        max-width: 100%;
        max-height: 100%;
      }
      .el-image{
        height: 100%;
      }
    }
  }
}

.card-table{
  margin-bottom: 25px;
  .missing {
    color: #91939a;
    font-size: 12px;
    font-style: italic;
  }
  .flie-name-len{
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header{
    background: #F6F8FA;
    border-radius: 6px 6px 0 0;
    border: 1px solid #D1D5DA;
    padding: 15px 13px;
    /deep/ .el-checkbox{
      .el-checkbox__label{
        white-space:normal;
      }
    }
  }
  .tr{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border: 1px solid #D1D5DA;
    border-top: 0;
    border-radius:0 0 6px 6px ;
  }
}
.btn-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.danger {
  color: #f56c6d;
  font-weight: 400;
  font-size: 14px;
}
.action-list{
  align-items: center;
  /deep/ .btn-label{
    font-weight: 400;
    font-size: 14px;
  }
}
.i-datetime-picker {
  width: 100%;
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input__inner{
    height: 32px;
    line-height: 32px;
  }
  .el-input__icon{
    line-height: 32px;
  }
}
</style>
